import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=f3829c64&scoped=true"
import script from "./SVGIcon.vue?vue&type=script&lang=js"
export * from "./SVGIcon.vue?vue&type=script&lang=js"
import style0 from "./SVGIcon.vue?vue&type=style&index=0&id=f3829c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3829c64",
  null
  
)

export default component.exports